// extracted by mini-css-extract-plugin
export default {"layerItem":"layerItem__QG9co"};